
import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useLoadingOverlayStore = defineStore('loading-overlay', () => {

    const overlayVisibility = ref(false)

    const show = () => {
        overlayVisibility.value     = true
    }
  
    const hide = () => {
        overlayVisibility.value     = false
    }

    return { 
        overlayVisibility, 
        show, 
        hide 
    }
})